









































































































































import Vue from "vue";
import { mdiClose } from "@mdi/js";
export default Vue.extend({
    props: { trackChangeNotifications: { type: Boolean, required: true } },
    data() {
        return { mdiClose: mdiClose };
    },
    methods: {
        closeDialog(): void {
            this.$emit("close");
        },
        openReleaseNotes(): void {
            this.$emit("openReleaseNotes");
        },
        openKeyboardShortcuts(): void {
            this.$emit("openKeyboardShortcuts");
        },
        updateTrackChangeNotifications(): void {
            this.$emit("updateTrackChangeNotifications");
        },
        toggleTheme(): void {
            this.$emit("toggleTheme");
        },
    },
});
